import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment"
import { HttpClient, HttpHeaders ,HttpParams} from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class TagService {


  constructor(private http : HttpClient) {}
  saveTag(request : any) {
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/tags/save",request,{observe:"response"});
   }
   getTagList(request:{page:any,size:any},search:{searchText:any,tagName:any,tagType:any}) {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
        httpParam=httpParam.append("page", request.page);
        httpParam=httpParam.append("size", request.size);
        httpParam=httpParam.append("tagType", search.tagType||'');
        httpParam=httpParam.append("tagName", search.tagName||'');
        httpParam=httpParam.append("searchText", search.searchText||'');
      return this.http.get( environment.API_URL+"/api/tags/list",{ observe : "body", params : httpParam,responseType : "json"})
   
  }

  getTagMappingList(data:any,request:any,search:any,tagged:any) {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
        // httpParam=httpParam.append("tagType", data.tagType);
        httpParam=httpParam.append("searchText", search?.searchText||'');
        httpParam=httpParam.append("customerId", '');
        httpParam=httpParam.append("mobile", '');
        httpParam=httpParam.append("customerType", '');
        httpParam=httpParam.append("page", request.page);
        httpParam=httpParam.append("size", request.size);
        httpParam=httpParam.append("tagged", tagged);

        
      return this.http.get( environment.API_URL+"/api/customer/list",{ observe : "body", params : httpParam,responseType : "json"})
   
  }


  getTagAllList() {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
        httpParam=httpParam.append("tagType", 'CARD');
        httpParam=httpParam.append("searchText", '');

        
      return this.http.get( environment.API_URL+"/api/tags/all",{ observe : "body", params : httpParam,responseType : "json"})
   
  }
  


}
